<template>
  <div class="text-left">
    <v-card>
      <v-form class="pa-6" ref="form">
        <v-row>
          <v-col cols="12">
            <h3 class="text-left">{{ $t("title.pressNewData") }}</h3>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-text-field
                v-model="pressNew.title"
                :label="$t('form.title')"
                outlined
                :rules="rules.char_required_max_200"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-menu
                v-model="menu_date"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                    v-model="pressNew.date"
                    :label="$t('form.date')"
                    prepend-inner-icon="event"
                    readonly
                    outlined
                    v-on="on"
                    :rules="rules.fieldRequired"
                ></v-text-field>
              </template>
              <v-date-picker
                  v-model="pressNew.date"
                  :first-day-of-week="1"
                  @input="menu_date = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col>
            <v-select
                v-model="pressNew.media_type"
                :items="media_types"
                :label="$t('form.pressNew.media_type')"
                outlined
                :rules="rules.fieldRequired"
            ></v-select>
          </v-col>
          <v-col>
            <v-select
                v-model="pressNew.scope"
                :label="$t('form.pressNew.scope')"
                :items="scope_types"
                outlined
                :rules="rules.fieldRequired"
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
                v-model="pressNew.media"
                :label="$t('form.pressNew.media')"
                outlined
                :rules="rules.char_required_max_100"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
                v-model="pressNew.uri"
                :label="$t('form.pressNew.uri')"
                :rules="rules.char_max_300"
                outlined
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" sm="6" md="6">
            <v-checkbox
              v-model="pressNew.hidden"
              :label="$t('form.hidden')"
            ></v-checkbox>
          </v-col>
          <v-col cols="6" sm="6" md="6">
            <v-checkbox
              v-model="pressNew.featured"
              :label="$t('form.featured')"
            ></v-checkbox>
          </v-col>
        </v-row>

        <h5 v-if="$route.params.id > -1">
          {{ $t("form.files") }}
        </h5>
        <UploadFiles
          v-if="pressNew.id !== undefined && $route.params.id > -1"
          object_type="news"
          :id="this.pressNew.id"
          :final="true"
        />

        <v-divider />
        <div class="text-center">
          <v-btn text @click="$router.back()"><v-icon left>mdi-arrow-left</v-icon>{{ $t("button.back") }}</v-btn>
          <v-btn color="primary" @click="save" class="ml-2"><v-icon left>mdi-content-save</v-icon>{{ $t("button.save") }}</v-btn>
        </div>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import validationRules from "../../mixins/validationRules";
import pressNew_model from "@/mixins/model_utils/pressNew_model";
import UploadFiles from "../../components/reusables/UploadFiles";

export default {
  components: { UploadFiles },
  mixins: [validationRules, pressNew_model],
  name: "EditPressNewDetail",
  data: () => ({
    menu_date: false,
    pressNew: {
      title: "",
      date: null,
      media_type: null,
      scope: "",
      media: "",
      uri: "",
      hidden: false,
      featured: false
    }
  }),

  created() {
    this.getMediaTypes();
    this.getScopeTypes();
    if (this.$route.params.id > -1) {
      this.getPressNew();
    }
  },

  computed: {
    processData() {
      let data = {
        title: this.pressNew.title,
        date: this.pressNew.date,
        type: this.pressNew.type,
        scope: this.pressNew.scope,
        uri: this.pressNew.uri,
        media: this.pressNew.media,
        media_type: this.pressNew.media_type,
        hidden: this.pressNew.hidden,
        featured: this.pressNew.featured
      };
      return data;
    }
  },

  methods: {
    getPressNew() {
      let path =
        this.$store.state.endpoint + "/news/" + this.$route.params.id;
      axios
        .get(path)
        .then(response => {
          this.pressNew = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    save() {
      if (this.$refs.form.validate()) {
        let path;
        if (this.$route.params.id > -1) {
          path =
            this.$store.state.endpoint +
            "/news/" +
            this.$route.params.id;
          axios
            .patch(path, this.processData)
            .then(() => {
              this.$store.commit("alert", {
                color: "success",
                text: this.$t("message.correct.updateItem")
              });
              this.$router.push("/manage/edit/pressNews");
            })
            .catch(error => {
              this.$store.commit("alert", {
                color: "error",
                text: error.response.data
              });
            });
        } else {
          path = this.$store.state.endpoint + "/news";
          axios
            .post(path, this.processData)
            .then(response => {
              this.$store.commit("alert", {
                color: "success",
                text: this.$t("message.correct.createItem")
              });
              this.$router.push("/manage/edit/pressNews");
              setTimeout(() => {
                this.$router.push("/manage/edit/pressNews/edit/" + response.data.id);
              }, 100); // Add a delay of 100 milliseconds
            })
            .catch(error => {
              console.log(error);
              this.$store.commit("alert", {
                color: "error",
                text: error.response.data
              });
            });
        }
      }
    }
  }
};
</script>
